import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import CommentIcon from '@material-ui/icons/Comment';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '35ch',
    },
    list: {
        // width: '600px',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '100%',
        color: theme.palette.success.main,
        right: 0
    },
}));


function NumberInput(props) {
    const classes = useStyles();
    const [error, setError] = useState(false)
    return (

        <FormControl className={clsx(classes.margin, classes.withoutLabel, classes.textField)}>
            <Input
                id="standard-adornment-weight"
                // value={form.weight}
                // onChange={handleChange('weight')}
                startAdornment={<InputAdornment position="start">{props.label}</InputAdornment>}
                endAdornment={<InputAdornment position="end">{props.unit}</InputAdornment>}
                aria-describedby="standard-weight-helper-text"
                type="number"
                error={error}
                inputProps={{
                    'aria-label': props.label,
                }}
                {...props}
                helperText={props.helperText}
                onChange={(e) => {
                    setError(props.validator(e.target.value))
                    props.onChange(e)
                }}
                onFocus={(event) => event.target.select()}
            />
            {/* <FormHelperText id="standard-weight-helper-text">{props.label}</FormHelperText> */}
        </FormControl>
    )
}

const fee_calc_maritime_direct = ({ billable_weight }) => {
    let maritime_direct = 0
    if (billable_weight <= 10) maritime_direct = null
    else if (billable_weight <= 70) maritime_direct = 30 * billable_weight
    else maritime_direct = 29 * billable_weight
    return maritime_direct
}

const fee_calc_maritime_special = ({ billable_weight }) => {
    let maritime_special = 0
    if (billable_weight <= 10) maritime_special = null
    else if (billable_weight <= 20) maritime_special = 34 * billable_weight
    else if (billable_weight <= 45) maritime_special = 33 * billable_weight
    else if (billable_weight <= 70) maritime_special = 32 * billable_weight
    else maritime_special = 30 * billable_weight
    return maritime_special
}

export { fee_calc_maritime_special, fee_calc_maritime_direct }


export default function CostCalc(props) {
    const classes = useStyles();
    const [form, setForm] = useState({ weight: 0, height: 0, width: 0, length: 0, method: undefined })
    const [cost, setCost] = useState({})
    const [expanded, setExpanded] = React.useState(false);

    const handlePanelChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const update_cost = (data) => {
        axios.post('/api/fee_calc', data).then(res => {
            setCost(res.data)
        })
    }

    const handleChange = (prop) => (event) => {
        let value = event.target.value
        value = parseFloat(event.target.value)

        let newform = { ...form, [prop]: value }

        setForm(newform);
        update_cost(newform)
    };

    useEffect(() => {
        update_cost(form)
    }, [])

    return (
        <div className={classes.root}>
            <Helmet>
                <title>运费计算器-小太阳速递</title>
            </Helmet>
            <Grid container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}>
                <Grid item xs>
                    <h1>小太阳速递运费计算器</h1>
                </Grid>
                <Grid item xs>
                    <NumberInput
                        value={form.weight}
                        onChange={handleChange('weight')}
                        label="包裹重量"
                        unit="千克（KG）"
                        validator={(value) => (!(value > 0))}
                        helperText="请输入重量"
                    />
                </Grid>
                <Grid item xs>
                    <NumberInput
                        value={form.length}
                        onChange={handleChange('length')}
                        label="包裹长度"
                        unit="厘米（cm）"
                        validator={(value) => (!(value > 0))}
                        helperText="请输入重量"
                    />
                </Grid>
                <Grid item xs>
                    <NumberInput
                        value={form.width}
                        onChange={handleChange('width')}
                        label="包裹宽度"
                        unit="厘米（cm）"
                        validator={(value) => (!(value > 0))}
                        helperText="请输入重量"
                    />
                </Grid>
                <Grid item xs>
                    <NumberInput
                        value={form.height}
                        onChange={handleChange('height')}
                        label="包裹高度"
                        unit="厘米（cm）"
                        validator={(value) => (!(value > 0))}
                        helperText="请输入重量"
                    />
                </Grid>
                <Grid item xs>
                    <h1>线路报价</h1>
                    {
                        (cost.warnings !== undefined) && cost.warnings.map((warning, index) => (
                                <Typography key={index} style={{ color: "#CC0000" }}>{warning}</Typography>
                            ))
                    }
                </Grid>
                <Grid item xs>

                    <List className={classes.list}>
                        {[
                            {
                                label: '私享小包裹', value: cost.tnt_express, content: (
                                    <>
                                        <Typography>时效：约2周</Typography>
                                        <Typography>✓ 1对1私享包裹服务 </Typography>
                                        <Typography> ✓ 抽真空服务减体积!</Typography>
                                        <Typography>无法承运：药品食品液体膏状大牌仿牌阿迪耐克电池易燃烟草</Typography>
                                        <Typography>详情参考<a target="_blank" href="https://xiaotaiyang.com.au/%e4%bb%b7%e6%a0%bc%e8%af%b4%e6%98%8e/">线路说明</a></Typography>
                                    </>
                                )
                            },
                            {
                                label: '万能线价格', value: cost.ems_express, content: (
                                    <>
                                        <Typography>时效：约2-8周（疫情期间时效不稳定）</Typography>
                                        <Typography>✓ 食品面膜 想寄就寄</Typography>
                                        <Typography>常见寄送：密封食品肉干螺蛳粉药品</Typography>
                                        <Typography>无法承运：液体粉末电池自热大牌仿牌易燃马达电器锡箔包装烟草</Typography>
                                        <Typography>详情参考<a target="_blank" href="https://xiaotaiyang.com.au/%e4%bb%b7%e6%a0%bc%e8%af%b4%e6%98%8e/">线路说明</a></Typography>
                                    </>
                                )
                            },
                            {
                                label: '电池线价格', value: cost.special_express, content: (
                                    <>
                                        <Typography>不拆包合并，原包装寄送</Typography>
                                        <Typography>实际重量/体积重量取高值，先结算后寄送</Typography>
                                        <Typography>时效：特殊线路时效约为2周，每1-2周发一批，如果物品比较多会每周发货 </Typography>
                                        <Typography>详情参考<a target="_blank" href="https://xiaotaiyang.com.au/%e4%bb%b7%e6%a0%bc%e8%af%b4%e6%98%8e/">线路说明</a></Typography>
                                    </>
                                )
                            },
                            {
                                label: '液体线价格', value: cost.special_express, content: (
                                    <>
                                        <Typography>不拆包合并，原包装寄送</Typography>
                                        <Typography>实际重量/体积重量取高值，先结算后寄送</Typography>
                                        <Typography>时效：特殊线路时效约为2周，每1-2周发一批，如果物品比较多会每周发货 </Typography>
                                        <Typography>详情参考<a target="_blank" href="https://xiaotaiyang.com.au/%e4%bb%b7%e6%a0%bc%e8%af%b4%e6%98%8e/">线路说明</a></Typography>
                                    </>
                                )
                            },
                            // {
                            //     label: 'VIP海运直邮线', value: cost.maritime_direct, content: (
                            //         <>
                            //             <Typography>免费拆包合并</Typography>
                            //             <Typography>￥30/kg</Typography>
                            //             <Typography>体积重量/10000,可邮寄食品 </Typography>
                            //             <Typography>详情参考<a target="_blank" href="https://xiaotaiyang.com.au/%e4%bb%b7%e6%a0%bc%e8%af%b4%e6%98%8e/">线路说明</a></Typography>
                            //         </>
                            //     )
                            // },
                            // {
                            //     label: '海运 - 特殊件直邮', value: cost.maritime_special, content: (
                            //         <>
                            //             <Typography>可邮寄液体和带电物品，高价值物品</Typography>
                            //             <Typography>阶梯定价￥30起，体积重量/6000</Typography>
                            //             <Typography>详情参考<a target="_blank" href="https://xiaotaiyang.com.au/%e4%bb%b7%e6%a0%bc%e8%af%b4%e6%98%8e/">线路说明</a></Typography>
                            //         </>
                            //     )
                            // },
                        ].map((item) => {
                            const labelId = `checkbox-list-label-${item.label}`;
                            return (
                                // <ListItem key={item.label} role={undefined} dense button >
                                //     <ListItemText id={labelId} primary={item.label} />
                                //     <ListItemSecondaryAction>

                                //     <ListItemText id={labelId} primary={<Typography>人民币¥{Math.round(item.value, 2)}</Typography>} />
                                //     </ListItemSecondaryAction>
                                // </ListItem>

                                <Accordion expanded={expanded === item.label} onChange={handlePanelChange(item.label)}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3bh-content"
                                        id="panel3bh-header"
                                    >
                                        <Typography className={classes.heading}>{item.label}</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            人民币¥{item.value === null ? ' (请私信客服询价)' : Math.round(item.value * 100, 2) / 100}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography align="left">
                                            {item.content}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            );
                        })}
                    </List>
                </Grid>
            </Grid>
        </div>
    );
}